<template>
	<div class="flex flex-1 h-screen justify-center items-center">
		<app-section class="h-auto bg-white lg:w-1/3 md:w-1/2 w-full m-4">
			<div class="flex flex-1 justify-center my-4">
				<img src="../assets/images/bab10vite.png" alt="Logo" class="w-48 p-1" />
			</div>
			<div class="flex flex-1 justify-center">
				<app-title title="Oops!" />
			</div>
			<div class="flex flex-1 my-4 justify-center">
				<p>We couldn't find what you're looking for!</p>
			</div>
			<div class="flex flex-1 mt-5 justify-center">
				<app-button class="btn btn-primary transparent" @click="goHome">Go Home</app-button>
			</div>
		</app-section>
	</div>
</template>

<script>
	import Names from '@/router/names';

	export default {
		name: 'NotFoundView',
		methods: {
			goHome() {
				this.$router.replace({ name: Names.OrdersList });
			},
		},
	};
</script>
